import lib from './lib';
import { LATITUDE, LONGITUDE } from '../models/MapPosition';

function transformPosition(position) {
  const libI = lib();
  return new libI.LatLng(position[LATITUDE], position[LONGITUDE]);
}

export default transformPosition;
